var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('div',{staticStyle:{"color":"#4caf50"}},[_vm._v("Zapnuto")]):_c('div',{staticStyle:{"color":"#f44336"}},[_vm._v("Vypnuto")])}
var staticRenderFns = []

export { render, staticRenderFns }